import styled, { css } from 'styled-components';
import getSafeDocumentBody from '@userzoomlibraries/toolkit-js-utils/get-safe-document-body';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import { useCallback } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import noop from '@userzoomlibraries/toolkit-js-utils/noop';
import getSafeHTMLElement from '@userzoomlibraries/toolkit-js-utils/get-safe-html-element';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import useEscape from '@userzoomlibraries/toolkit-react-utils/use-escape';
import useDisableBackgroundScroll from '@userzoomlibraries/toolkit-react-utils/use-disable-background-scroll';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className", "container", "disableClickOutside", "disableEscape", "preventDisableScroll", "onClose"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Backdrop$1 = function Backdrop(_ref) {
  var className = _ref.className,
      container = _ref.container,
      disableClickOutside = _ref.disableClickOutside,
      disableEscape = _ref.disableEscape,
      preventDisableScroll = _ref.preventDisableScroll,
      onClose = _ref.onClose,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dataAttributes = useDataAttributes(rest);
  useEscape({
    onEscape: onClose,
    preventClose: disableEscape
  });
  useDisableBackgroundScroll({
    enabled: !preventDisableScroll,
    elementToBlock: container
  });
  var backdropHandler = useCallback(function (event) {
    if (!disableClickOutside) {
      onClose(event);
    }
  }, [disableClickOutside, onClose]);
  return /*#__PURE__*/jsx("div", _objectSpread({
    className: "gz-backdrop ".concat(className),
    onMouseUp: backdropHandler // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes));
};

Backdrop$1.COMPONENT_ID = 'Gearz.Backdrop';
Backdrop$1.displayName = Backdrop$1.COMPONENT_ID;
Backdrop$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  container: PropTypes.oneOfTypeWithDescription([PropTypes.string, // element id
  PropTypes.instanceOf(getSafeHTMLElement()) // dom element
  ], 'Container of the backdrop. (DOM id or DOM element)'),
  disableClickOutside: PropTypes.boolWithDescription('Flag to activate/deactivate the click outside.'),
  disableEscape: PropTypes.boolWithDescription('Flag to activate/deactivate the escape event.'),
  preventDisableScroll: PropTypes.boolWithDescription('Flag to activate/deactivate the background scroll.'),
  onClose: PropTypes.funcWithDescription('Callback called when the backdrop is closing.')
};
Backdrop$1.defaultProps = {
  className: '',
  container: getSafeDocumentBody(),
  disableClickOutside: false,
  disableEscape: true,
  preventDisableScroll: false,
  onClose: noop
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Backdrop = styled(Backdrop$1).withConfig({
  componentId: "gz-backdrop-1673535241886__sc-4hwmvc-0"
})(["background-color:rgba(0,0,0,0.35);bottom:0;display:block;left:0;outline:0;position:fixed;right:0;top:0;z-index:2000;", " ", ";"], function (_ref) {
  var container = _ref.container;

  if (container !== getSafeDocumentBody()) {
    return css(["position:absolute;"]);
  }

  return null;
}, function (props) {
  return getThemeByProps({
    componentId: Backdrop$1.COMPONENT_ID,
    props: props
  });
});
Backdrop.displayName = Backdrop$1.displayName;
Backdrop.propTypes = Backdrop$1.propTypes;
Backdrop.defaultProps = Backdrop$1.defaultProps;

export { Backdrop as B };
